import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { fetchProducts } from "../actions/ProductActions";
import { useNavigate } from "react-router-dom";
import { SimpleProductPageSkeleton } from "../components/HomeSkeletons";
import ProductCard from "../components/ProductCard";
import { SelectTrendingProducts } from "../selectors/ProductSelector";
import Pagination from "../components/Pagination";
import "../styles/new.css";
import { fetchFilteredProducts } from "../actions/FilterActions";

function ProductsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const { loading, error, count, filteredProducts } = useSelector(
    (state) => state.filters
  );
  // const trendingProducts = useSelector(SelectTrendingProducts);

  const productsPerPage = 30;
  const totalPages = Math.ceil(count / productsPerPage);

  useEffect(() => {
    dispatch(
      fetchFilteredProducts({
        tags: ["HOT DEAL"],
        status: "published",
        page: currentPage,
        pagination: productsPerPage,
      })
    );
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  if (loading)
    return (
      <SimpleProductPageSkeleton gridClassName="new-products-grid" cardCount={15} />
    );
  if (error) return <div>Error: {error}</div>;
  if (filteredProducts && filteredProducts.length === 0)
    return <div>No trending products available.</div>;

  const handleProductClick = (product) => {
    navigate(`/product/${product.slug || product.product_id}`);
  };

  return (
    <div className="products-page new-products-container">
      <h1 className="new-products-title">Hot Deals</h1>
      <p className="new-products-description">
        Hot deals right now - don't miss out!
      </p>
      <div className="new-products-grid">
        {filteredProducts &&
          filteredProducts.length > 0 &&
          filteredProducts.map((product) => (
            <div
              key={product.product_id}
              onClick={() => handleProductClick(product)}
            >
              <ProductCard product={product} preferredTag="HOT DEAL" />
            </div>
          ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default ProductsPage;
